module.exports = __webpack_public_path__ + "static/pillage-1fa6bcfe46e30917eb128cefd98d32ce.png";